import { useNavigate } from "@tanstack/react-router";
import { Button, FunnelIcon } from "@theprelude/ds";
import { Category } from "@/components/filter-form/top-level-form";
import { useTopLevelFiltersFor } from "@/queries/control-monitor";
import { Callout } from "../callout";

export function TopLevelFilterIndicator({ category }: { category: Category }) {
  const topLevelFilters = useTopLevelFiltersFor(category);
  const navigate = useNavigate();

  if (topLevelFilters.length === 0) {
    return null;
  }

  return (
    <Callout icon={<FunnelIcon className="size-4" />}>
      <span>Some {category} are excluded by a global filter.</span>
      <Button
        onClick={() =>
          navigate({
            to: window.location.pathname,
            params: (prev) => ({ ...prev }),
            search: (prev) => ({ ...prev, filters: undefined }),
          })
        }
        intent="text-link"
        className="ml-3 p-0"
      >
        Clear
      </Button>
    </Callout>
  );
}
